import styled from 'styled-components';
import {
  desktop_breakpoint,
  desktop_container_maxwidth,
  lg_mobile_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const BuilderLinksByStateStyles = styled.div`
  .builders-state-container {
    padding: 0 24px 96px 24px;
    .markdown {
      h2 {
        line-height: 30px;
        font-weight: 700;
      }
    }

    .markdown {
      h1,
      h2,
      h3,
      p {
        color: inherit;
      }
    }

    ul {
      margin-top: '24px';
      width: 100%;
      .builders-list-left {
        li {
          a {
            color: inherit;
          }
        }
      }

      .builders-list-right {
        li {
          a {
            color: inherit;
          }
        }
      }
    }

    .view-all {
      a {
        color: ${Colors.primary.claytonBlue.standard};
        text-decoration: underline;
        svg {
          vertical-align: middle;
          margin-left: 4px;
        }
      }
    }
  }

  @media screen and (min-width: ${lg_mobile_breakpoint + 103}px) {
    .builders-state-container {
      ul {
        display: inline-flex;
        gap: 20%;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .builders-state-container {
      width: 80%;
      margin: auto;
      padding: 0 0 96px 0;
      max-width: ${desktop_container_maxwidth}px;

      ul {
        display: inline-flex;
        gap: 30%;
      }
    }
  }
`;

export default BuilderLinksByStateStyles;
